<template>
  <v-container
    fluid
    class="fill-height pa-0"
  >
    <v-row
      justify="center"
      align="center"
      class="fill-height ma-0"
    >
      <loading-screen v-if="isLoading"/>
      <v-btn v-else-if="showRedirectToLogin" @click="redirectLogin" depressed>
        Tentar novamente?
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
  import {getAllScopes, IDTokenInvalidNonce, UserData} from "../api/api-auth"
  import {SET_USER_DATA} from "../store/modules/user"
  import {mapActions} from "vuex"
  import {DIALOG_TYPES, DialogOptions} from "../helpers/dialogs"
  import LoadingScreen from "../components/Helpers/LoadingScreen"
  // import {FLOWS_IDS} from "../helpers/conpass/constants"
  // import * as Sentry from "@sentry/vue";

  export default {
    name: "RedirectAuth",
    components: {LoadingScreen},
    data: () => ({
      title: null,
      message: null,
      icon: null,
      color: null,
      showRedirectToLogin: false,

      isLoading: true,
    }),
    methods: {
      setErrorPage() {
        this.isLoading = false

        this.title = "Ops! Houve um problema com seu login."
        this.message = "Por favor, tente novamente."
        this.icon = "mdi-alert"
        this.color = "error"

        this.showRedirectToLogin = true
      },
      redirectLogin() {
        this.$router.replace("/login")
      },
      afterLogin() {
        this.isLoading = true
        this.$apiAuth.whoami()
          .then((response) => {
            const userData = UserData.fromObject(response.data)
            this.setUserData(userData)
            // Sentry.setUser({ 
            //     id: userData.idUserAccount,
            //     email: userData.strEmail, 
            //     username: userData.strName
            //   });

            if (!userData.blEmailValidated) {
              this.$dialog(new DialogOptions({
                title: "Verificação de e-mail",
                persistent: true,
                content: "Sua conta ainda não foi verificada, por favor acesse seu e-mail e confirme a verificação para continuar na plataforma",
                cancelText: "Ok, entendi",
                confirmText: "Reenviar e-mail",
                type: DIALOG_TYPES.CONFIRM,
                onConfirm: () => {
                  this.$apiAuth.requestResendToken(userData.strEmail)
                    .then(() => {
                      this.$router.push("/login")
                    })
                    .catch(() => {
                      this.$router.push("/login")
                    })
                  },
                onCancel: () => {
                  this.$apiAuth.logout()
                    .then(() => {
                      this.$router.push("/login")
                    })
                    .catch(() => {
                      this.$router.push("/login")
                    })
                },
              }))
              return
            }
            // FIXME: Definir se é o primeiro login do infeliz de alguma forma
            const firstLogin = window.localStorage.getItem("fl") === "1"

            if (firstLogin) {
              this.firstLogin(userData)
            } else {
              const redirectAfterLogin = window.localStorage.getItem("ral")
              if (redirectAfterLogin) {
                window.localStorage.removeItem("ral")
                this.$router.push(redirectAfterLogin)
              } else {
                this.$router.push("/app")
                this.$subsMng.getSubscription(this.$apiAuth.getAuthToken())
                  .then(() => {
                    // window.Conpass.startFlow(FLOWS_IDS.SECOND_LOGIN)
                    console.log('')
                  })
              }
            }
          })
          .catch(() => {
            this.setErrorPage()
          })
          .finally(() => {
            this.isLoading = false
          })
      },

      firstLogin() {
        // TODO: Definir fluxo do usuario internacional
        this.$router.push("/app")
      },

      ...mapActions({
        setUserData: SET_USER_DATA,
      }),
    },
    created() {
      this.$apiAuth.afterRedirectHandler(
        this.$route.query, getAllScopes(),
        () => {
          this.afterLogin()
        },
        (err) => {
          let message = err
          if (err instanceof IDTokenInvalidNonce) {
            message = "invalid nonce"
          }

          this.setErrorPage(message)
        },
      )
    },
  }
</script>

<style scoped>

</style>
